// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0d3510da","239":"1469ae3c","453":"eb8f21d1","732":"236de84c"}[chunkId] + ".chunk.js";
};